<div class="disclaimer-main">
  <div class="col-lg-12 row">
    <div class="col-lg-2"></div>
    <div class="col-lg-8">
      <h2 class="text-center heading-main p-3">Disclaimer</h2>
      <div class="risk-data">

        <div class="risk-content p-3">
          <p>Access to the information provided on this web site is not intended and shall not be treated as an offer to
            sell or the solicitation of
            an offer to buy any security nor shall it be construed as creating any privity of contract between ITI Asset
            Management Limited (ITIAML)
            and any person availing of or acting upon any information available on this web site. The work of authorship
            contained in this web site,
            including but not limited to design, text, and images are proprietary and the same shall not be copied,
            reproduced, transmitted, displayed,
            distributed, altered or otherwise used in whole or in part in any manner. While all efforts have been taken
            to make this web site as
            authentic as possible, ITIAML, will not be responsible for any liability in respect of any person/entity
            directly or indirectly
            suffering any consequential losses, damages or claims of whatsoever nature as a result of any short-coming,
            defect or inaccuracy
            inadvertently crept in this website or otherwise using the information available on this website in any
            manner. Despite all possible
            security measures that ITIAML takes to keep this website free from hacking and other interference, this
            website like any other site is
            not free from such risks. ITIAML disclaims all liability on account of any loss or damage that any user may
            suffer or incur on account
            of any alteration or manipulation of any data or information accessed or downloaded from this web site.</p>
          <p>All the contents of this site are only for general information or use. They do not constitute advice and
            should not be relied upon in making
            any investment decision. In case of any omission or discrepancy, information in the original records will be
            final and binding. It is also not
            guaranteed that information published in this Website is up to date. The AMC, Trustee, Sponsors or the
            Directors/employees of the AMC,
            Trustees or Sponsors of ITI Mutual Fund hereby excludes any liability, warranty, express or implied, as to
            the quality, accuracy, timeliness,
            completeness, performance, fitness for a particular purpose of the Site or any of its contents, including
            (but not limited) to any financial tools
            contained within the Site.</p>
          <p>Despite our best efforts, we do not guarantee that the documents in this site are free from infection by
            computer viruses etc.
          </p>
        </div>
      </div>

      <h3 class="heading-sub  pt-3 pl-3">
        Disclaimer for US Citizens
      </h3>
      <div class="risk-content p-3">
        <p>ITI Asset Management Limited (ITIAML) is not a registered entity under the U.S. Securities Exchange Act of
          1934, as amended (the“1934 act”)
          and under applicable state laws in the United States. In addition ITIAML is not a registered investment
          adviser under the U.S. Investment Advisers
          Act of 1940, as amended (the "Advisers Act" and together with the 1934 Act, the “Acts”), and under applicable
          state laws in the United States.
          Accordingly, in the absence of specific exemption under the Acts, any investment products provided by ITIAML,
          including the products and services
          described herein are not available to or intended for U.S. persons.</p>
        <p>"U.S. Persons" are generally defined as a natural person, residing in the United States or any entity
          organized or
          incorporated under the laws of the United States. US Citizens living abroad may also be deemed "US Persons"
          under certain rules.</p>
        <p>ITI Asset Management Limited (ITIAML) is a wholly owned subsidiary of The Investment Trust of India
          (erstwhile, Fortune Financial Services
          (India) Limited). ITIAML and/or its subsidiaries/associated companies is/are resident outside the United
          States (U.S.) and are not associated
          persons of any U.S. regulated entity and therefore ITIAML and/or its subsidiaries/associated companies is/are
          not subject to supervision by
          any U.S. entity/authority, and is/are not required to satisfy the regulatory licensing requirements of the
          Financial Industry Regulatory
          Authority (FINRA) or required to otherwise comply with U.S. rules or regulations regarding, among other
          things, communications with a subject
          company, public appearances and trading securities.</p>
        <p>ITIAML shall not be liable for any delay or any other interruption which may occur in placing the data on the
          website due to any reason including
          network (Internet) reasons or snags in the system, break down of the system or any other equipment, server
          breakdown, maintenance shutdown,
          breakdown of communication services or inability of ITIAML to place the data on the website. In no event shall
          ITIAML be liable for any damages,
          including without limitation direct or indirect, special, incidental, or consequential damages, losses or
          expenses arising in connection with the
          data provided by ITIAML.</p>
      </div>
    </div>

  </div>
  <div class="col-lg-2"></div>
</div>
